import { useState, useEffect, useContext, useCallback  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';
import { InfoToolTip } from '../commonComponents/generalComponents';


const StoreStatsViewer = (props) => {
    //props:

    const [topStores, setTopStores] = useState([])
    const [previewImages, setPreviewImages] = useState({})

  const getPreviewImages = async (ids) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Templates/storePreview`;
      const dataToPost = {snippetId: props.snippetId, ids: ids}
      const response = await axios.post(url, dataToPost);
      const data = response.data;

      //console.log(data)
      setPreviewImages(data)

    } catch (error) {
      console.log(error);
    }
  }


    useEffect(() => {
        setTopStores([])
        if (props.stats && props.stats.length > 0) {
              const top =props.stats.filter(s => s.storeId != null && s.storeId !== '' && s.storeId !== 'null').slice(0,3)
              setTopStores(top)
              getPreviewImages(top.map(t => t.storeId))
        }
    }, [props.stats])

    function formatNumber(value) {
    return new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(value);
    }

  return <div>
            <div className='text-2xl text-ccColorDarkTeal font-semibold'>Most Viewed</div>
          <div className='grid grid-cols-2 mt-4 gap-4'>
              {topStores?.map((s, index) => <div>
                <div className='flex flex-row items-center gap-x-4 mb-1'>
                  <div className='font-bold text-ccColorTeal'>Number {index+1}</div>
                  <InfoToolTip
                      slotProps={{
                                  tooltip: {
                                    sx: {maxWidth: 500,},
                                  },
                                }}
                      custom={<div className='text-ccColorDarkTeal text-sm border border-ccColorTeal px-2 rounded'>View Store</div>}
                      placement='right'
                      headLine=''
                      message={<div className="font-poppins text-ccColorDarkTeal w-96">
                                  <div className='flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">Store Id</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">{s.storeId}</div>
                                  </div>
                                  <div className='mt-2 flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">Store Name</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">{previewImages[s.storeId]?.row.storeName}</div>
                                  </div>
                                  <div className='mt-2 flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">Address 1</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">{previewImages[s.storeId]?.row.address1}</div>
                                  </div>
                                  <div className='mt-2 flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">Address 2</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">{previewImages[s.storeId]?.row.address2}</div>
                                  </div>
                                  <div className='mt-2 flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">City</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">{previewImages[s.storeId]?.row.city}</div>
                                  </div>
                                  <div className='mt-2 flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">Country</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">{previewImages[s.storeId]?.row.country}</div>
                                  </div>
                                  <div className='mt-2 flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">Lat,Lng</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">({previewImages[s.storeId]?.row.latitude}, {previewImages[s.storeId]?.row.longitude})</div>
                                  </div>
                                  <div className='mt-2 flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">Custom 1</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">{previewImages[s.storeId]?.row.custom1}</div>
                                  </div>
                                  <div className='mt-2 flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">Custom 2</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">{previewImages[s.storeId]?.row.custom2}</div>
                                  </div>
                                  <div className='mt-2 flex flex-row items-center'>
                                    <div className="h-7 w-[108px] flex items-center font-bold px-2 bg-slate-200 rounded-s border border-slate-200">Custom 3</div>
                                    <div className="h-7 w-[264px] flex items-center text-gray-600 text-sm px-2 rounded-e border border-slate-200 truncate">{previewImages[s.storeId]?.row.custom3}</div>
                                  </div>
                              </div>}
                  />
                  
                </div>
                <div className='flex flex-row gap-x-4 relative'>
                    <div className='bg-slate-200 rounded p-4 w-[400px] h-[300px] flex justify-center relative'>
                        <div className='h-full' >

                            <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={previewImages[s.storeId]?.img} />
                        </div>                   
                    </div>
                    <div className='flex flex-col'>
                        <div className='flex flex-row gap-x-8'>
                        <div className='flex flex-col gap-y-2 p-2'>
                            <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                            <div>Opens</div>
                            <div className='text-2xl font-semibold'>{s.totalOpens}</div>
                            </div>
                            <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                            <div>Clicks</div>
                            <div className='text-2xl font-semibold'>{s.totalClicks}</div>
                            </div>
                        </div>
                        </div>
                    </div>
                  </div>
              </div>)
              }
          </div>
      </div>
}

const FallbackViewer = (props) => {
    const [fallback, setFallback] = useState({})

    useEffect(() => {
        setFallback({})
        if (props.stats && props.stats.length > 0) {
            let opens = 0
            let clicks = 0
            const fallbackStores =props.stats.filter(s => s.storeId == null || s.storeId === '' || s.storeId === 'null')
            for (const s of fallbackStores) {
              opens += s.totalOpens
              clicks += s.totalClicks
            }
            setFallback({totalOpens: opens, totalClicks: clicks})            
         }
    }, [props.stats, props.fallbackReport])

    return <div>
              <div className='text-2xl text-ccColorDarkTeal font-semibold'>Fallback</div>
             <div className='flex flex-row gap-x-4 relative'>
                    <div className='bg-slate-200 rounded p-4 w-[400px] h-[300px] flex justify-center relative'>
                        <div className='h-full' >
                            <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={props.img} />
                        </div>                   
                    </div>
                    <div className='flex flex-col'>
                        <div className='flex flex-row gap-x-8'>
                        <div className='flex flex-col gap-y-2 p-2'>
                            <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                            <div>Opens</div>
                            <div className='text-2xl font-semibold'>{fallback.totalOpens}</div>
                            </div>
                            <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                            <div>Clicks</div>
                            <div className='text-2xl font-semibold'>{fallback.totalClicks}</div>
                            </div>
                        </div>
                        </div>
                    </div>
                  </div>
                </div>
}

export default function SnippetNearestStoreReport(props) {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [stats, setStats] = useState(undefined)
    const [imgUrls, setImgUrls] = useState(undefined)
    const [generateDirections, setGenerateDirections] = useState('Yes')
    const [fallbackImage, setFallbackImage] = useState(undefined)

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetInfo(undefined)
        setImgUrls(undefined)
        getSnippetStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/nearestStore/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setStats(data)

    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetInfo(data)
      const settings = JSON.parse(data.snippetSettings)
      setGenerateDirections(settings.hrefMode === 'directions' ? 'Yes' : 'No')
      setFallbackImage(settings.fallbackImage)
      //setImgUrls(settings.images.map(i => i.imgB64))

    } catch (error) {
      console.log(error);
    }
  }


    return <div>
            <CcTitle>Nearest Store Report</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Total Views', value: stats?.totalOpens},
                                    {title: 'Total Clicks', value: stats?.totalClicks},
                                    {title: 'Fallback Views', value: stats?.fallbackOpens},
                                    {title: 'Generate Directions', value: generateDirections},
                                    ]} />
            </div>
            <div className='mt-6'>
              <StoreStatsViewer stats={stats?.orderedStoreStats}
              snippetId={params.snippetId}
               />
            </div>
            <div className='mt-6'>
              <FallbackViewer stats={stats?.orderedStoreStats}
                img={fallbackImage}
               />
            </div>
    </div>
}